module.exports = __webpack_public_path__ + "static/media/logo_white.2efd7dc5.png";